import { render, staticRenderFns } from "./DashboardFM.vue?vue&type=template&id=48e3d0c8&"
import script from "./DashboardFM.vue?vue&type=script&lang=js&"
export * from "./DashboardFM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports